<script>
	export let displayName;
	export let photoURL;
	export let uid;
	import { db, fb } from "./firebase";
	import { collectionData } from "rxfire/firestore";
	import { startWith } from "rxjs/operators";

	import { auth, googleProvider } from '../components/firebase';
	// export let auth, providerData;
	import CopyClipBoard from './CopyClipboard.svelte';
	// import { toast } from '@zerodevx/svelte-toast'

	import {notifications} from './notifications.js'

	import { createEventDispatcher } from "svelte";

	export const dispatch = createEventDispatcher();

	function upgradeUser(){
		const provider = googleProvider;
		fb.auth().currentUser.linkWithPopup(provider)
		console.log(provider)
	}

	let selected = ''
	export let boardID;
	// export let currentBoard;
	let deckTitle = 'title';
	export let permissions;
	export let title;

	export let shareSlug;
	let slugTrail, finalSlug;

	const query = db.collection("boards").where("uid", "==", uid);

	const boards = collectionData(query, "boardID").pipe(startWith([]));

	export let menuVisible = true

	let copyText = window.location + "?share=" + uid;

	$: if (boards != "" && boards != undefined) {       // make it react to changes (in the parent)
      // console.log("boards")
			// console.log($boards)
			let s = $boards;
			sendBoards();
  }; 

	function sendBoards() {
		dispatch("get", {
			boardList: $boards
		});
	}

	const copy = () => {
		const app = new CopyClipBoard({
			target: document.getElementById('clipboard'),
			props: { copyText },
		});
		app.$destroy();
	}

	function changeBoard() {
		dispatch("change", {
			selected
		});
	}

	function clearBoard() {
		menuVisible = true
		dispatch("change", {
			selected: ""
		});
	}

	// Create a deck
	async function createDeck() {
		// const firestore = firebase.firestore();
		
		const data = {};

		const doc = await db.collection('decks').add(data);
		console.log('Deck created', {
			id: doc.id,
			data: data
		});
		
		const d2 = {
			boardID: doc.id,
			title: deckTitle,
			uid: uid
		}
		await db.collection('boards').add(d2)
		selected = doc.id;
		changeBoard();

		return doc.id;
	}


	function toggleMenu(){
		// if(permissions ==  "true"){
		// 	menuVisible = !menuVisible;
		// }
		menuVisible = !menuVisible
	}

	async function setShareLink(){
		var deckRef = db.collection('boards').doc(boardID);

		if(shareSlug != '' && shareSlug != undefined){
			var setWithMerge = deckRef.set({
				shareSlugText: shareSlug,
				shareSlug: shareSlug + slugTrail
			}, { merge: true });
			// COPY TO CLIPBOARD
			copyText = "https://brick.rip/share/"+shareSlug+slugTrail;
			const app = new CopyClipBoard({
				target: document.getElementById('clipboard'),
				props: { copyText },
			});
			app.$destroy();
			// toast.push('Copied to clipboard!')
			notifications.success("Copied to clipboard", 3000)
		}else{
			// alert("Please enter a value")
			notifications.warning("Please enter a value", 1000)
		}
	}

	function getSlug(){
		var docRef = db.collection("boards").doc(boardID);
		docRef.get().then((doc) => {
				if (doc.exists) {
						console.log("Document data:", doc.data());
				} else {
						// doc.data() will be undefined in this case
						console.log("No such document!");
				}
		}).catch((error) => {
				console.log("Error getting document:", error);
		});
	}

	$: if (boardID != "" && boardID != undefined) {       // make it react to changes (in the parent)
			slugTrail = "-"+boardID.substring(boardID.length - 5);
			// getSlug()
			removeSpaces()
  };

	function removeSpaces(){
		if(shareSlug != '' && shareSlug !=undefined){
			shareSlug = shareSlug.replace(/\s/g , "-");
			finalSlug = shareSlug + slugTrail
		}
	}





	
</script>

<svg class="logo" class:small="{boardID != '' && boardID != undefined}" viewBox="0 0 721 150" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Group</title>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Artboard" transform="translate(-68.000000, -115.000000)">
            <rect id="Rectangle" fill="#262728" x="33" y="30" width="1429" height="318" rx="8"></rect>
            <g id="Group" transform="translate(68.058582, 115.509369)" fill="#EFF0F2" fill-rule="nonzero">
                <path d="M58.3734398,145.490631 C88.692191,145.490631 106.903129,130.232818 106.903129,105.229692 C106.903129,86.7234409 94.1062537,73.0406279 74.9109405,71.0718778 L74.9109405,69.3984403 C88.889066,67.0359402 99.815629,53.7468771 99.815629,38.882814 C99.815629,17.0296882 83.7703158,3.44531264 57.0937523,3.44531264 L-6.82121026e-13,3.44531264 L-6.82121026e-13,145.490631 L58.3734398,145.490631 Z M48.2343769,63.5906275 L22.0500009,63.5906275 L22.0500009,22.1484384 L51.9750021,22.1484384 C68.3156277,22.1484384 77.8640656,29.8265637 77.8640656,42.9187517 C77.8640656,56.4046897 67.7250027,63.5906275 48.2343769,63.5906275 Z M53.9437521,126.787505 L22.0500009,126.787505 L22.0500009,81.0140657 L52.6640646,81.0140657 C73.4343779,81.0140657 84.3609409,88.7906285 84.3609409,103.654692 C84.3609409,118.71563 73.8281279,126.787505 53.9437521,126.787505 Z M146.104694,145.490631 L146.104694,91.3500036 L177.210945,91.3500036 L206.151571,145.490631 L231.646885,145.490631 L199.753133,87.707816 C217.078134,81.8015658 227.315634,66.2484401 227.315634,47.1515644 C227.315634,20.4750008 208.907821,3.44531264 180.262508,3.44531264 L124.054693,3.44531264 L124.054693,145.490631 L146.104694,145.490631 Z M177.80157,72.5484404 L146.104694,72.5484404 L146.104694,22.8375009 L177.210945,22.8375009 C194.240633,22.8375009 204.675009,32.1890638 204.675009,47.6437519 C204.675009,63.49219 194.831258,72.5484404 177.80157,72.5484404 Z M269.667199,145.490631 L269.667199,3.44531264 L247.617198,3.44531264 L247.617198,145.490631 L269.667199,145.490631 Z M352.37814,148.935943 C384.075017,148.935943 407.404705,130.232818 411.342205,102.178129 L389.390642,102.178129 C385.453142,118.223442 371.179704,128.362505 352.37814,128.362505 C326.784389,128.362505 310.837514,107.592192 310.837514,74.5171905 C310.837514,41.3437516 326.784389,20.5734383 352.279703,20.5734383 C370.982829,20.5734383 385.256267,31.7953138 389.390642,49.218752 L411.342205,49.218752 C407.798455,20.2781258 383.582829,0 352.279703,0 C312.806264,0 288.295325,28.4484386 288.295325,74.5171905 C288.295325,120.487505 312.904701,148.935943 352.37814,148.935943 Z M451.232832,145.490631 L451.232832,98.8312539 L467.179708,81.0140657 L514.82346,145.490631 L542.385961,145.490631 L482.732833,65.1656276 L537.660961,3.44531264 L511.575022,3.44531264 L452.807832,69.9890653 L451.232832,69.9890653 L451.232832,3.44531264 L429.182831,3.44531264 L429.182831,145.490631 L451.232832,145.490631 Z" id="BRICK"></path>
                <path d="M563.567485,146.250982 C567.369244,146.250982 570.142291,143.343756 570.142291,139.586724 C570.142291,135.829692 567.369244,132.922466 563.567485,132.922466 C559.810454,132.922466 556.99268,135.829692 556.99268,139.586724 C556.99268,143.343756 559.810454,146.250982 563.567485,146.250982 Z M596.083699,145.490631 L596.083699,120.891019 L610.217294,120.891019 L623.366905,145.490631 L634.951085,145.490631 L620.459678,119.236136 C628.331554,116.552542 632.983117,109.485745 632.983117,100.808791 C632.983117,88.6878914 624.619249,80.9501955 611.603818,80.9501955 L586.064948,80.9501955 L586.064948,145.490631 L596.083699,145.490631 Z M610.485654,112.348245 L596.083699,112.348245 L596.083699,89.761329 L610.217294,89.761329 C617.95499,89.761329 622.696006,94.0103528 622.696006,101.032424 C622.696006,108.233401 618.22335,112.348245 610.485654,112.348245 Z M657.269642,145.490631 L657.269642,80.9501955 L647.250891,80.9501955 L647.250891,145.490631 L657.269642,145.490631 Z M683.434683,145.490631 L683.434683,123.75352 L698.373357,123.75352 C711.030975,123.75352 719.976288,115.076566 719.976288,102.463674 C719.976288,89.6718759 711.299334,80.9501955 698.686443,80.9501955 L673.415933,80.9501955 L673.415933,145.490631 L683.434683,145.490631 Z M696.047575,114.942386 L683.434683,114.942386 L683.434683,89.8060556 L696.047575,89.8060556 C704.858709,89.8060556 709.733904,94.2787122 709.733904,102.463674 C709.733904,110.469729 704.679802,114.942386 696.047575,114.942386 Z" id=".RIP"></path>
            </g>
        </g>
    </g>
</svg>

<!-- <img src={photoURL} width="100" alt="user avatar" /> -->
<!-- <p>Your userID is {uid}</p> -->
{#if boardID != '' && boardID != undefined}
	<p class="type-sm">Add bricks to decks and then share.  EZPZ</p>
	<p class="type-sm">{title}</p>
{:else}
	<!-- <p>Select or create deck to begin</p> -->
	<p class="type-sm">Authenticated as {displayName}. Brick.rip is a free moodboard site designed for information heirarchies and quick sharing.</p>
	<p class="type-sm">To begin, select or create a new deck.</p>
{/if}

{#if displayName == "null" || displayName == null}
	<button class="button" on:click={upgradeUser}>Make account</button>
{/if}


<!-- <button id="copyClip" on:click={copy}>Copy share link</button> -->

<button class="button" on:click={clearBoard}>View All</button>

{#if boardID !='' && boardID != undefined}
	<button class="button" on:click={() => toggleMenu()}>Share...</button>
{/if}


<div class="share-menu" class:hidden={menuVisible==true}>
	<!-- <div class="share-background"></div> -->
	<div class="share-card">
		<p class="type-m">Create a share link for the board and then share</p>
		<input class="minimalInput" bind:value={shareSlug} on:input={removeSpaces} type="text" placeholder="Share ID">
		<button class="button" on:click={setShareLink}>Get link</button>
		<button class="button" on:click={toggleMenu}>Close</button>
		<p class="type-sm">&nbsp;</p>
		<p class="type-sm">brick.rip/share/{shareSlug}{slugTrail}</p>
	</div>
</div>


<div id="clipboard"></div>
<!-- {#each $boards as board}
	<p>{board.title}</p>
{/each}



<p>
	<select bind:value={selected} on:change={changeBoard}>
		<option value="" >Show All</option>
		{#each $boards as board}
		<option value={board.boardID}>{board.title}</option>
		{/each}
	</select>
</p>

<input type="text" bind:value={deckTitle}>
<button on:click={createDeck}>Create Deck</button> -->

<style>
	.logo{
		width: 80%;
		margin-bottom: 5px;
		transition: all 0.3s;
	}

	.small{
		width: 20%;
	}
	#copyClip{
		border: none;
		padding: 8px 12px;
		background: #00000050;
		color: black;
		cursor: pointer;
		border-radius: 8px;
	}
	#copyClip:hover{
		background: rgba(0, 0, 0, 0.963);
		color: white;
	}

	.button{
		margin-top: 6px;
		border: none;
		padding: 8px 12px;
		background: #EFF0F2;
		color: black;
		cursor: pointer;
		border-radius: 6px;
	}
	.button:hover{
		background: rgba(0, 0, 0, 0.963);
		color: white;
	}
	h3{
		margin-block-end: 4px !important;
	}

	.type-sm{
		margin-bottom: 5px;
	}

	.share-menu{
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0px;
		left: 0px;
		display: flex;
		justify-content: center;
		align-items: center;
		pointer-events: none;
		z-index: 40;
	}
	.share-background{
		position: absolute;
		width: 100%;
		height: 100%;
		background-color: #00000010;
		pointer-events: all;
	}
	.share-card{
		background-color: rgb(83, 158, 142);
		pointer-events: all;
		border-radius: 8px;
		box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.267);
		color: white;
		padding: 30px;
	}

	.minimalInput{
        border: none;
        background-color: rgba(0, 0, 0, 0.062);
        color: white;
        font-size: 18px;
        line-height: 1;
				padding: 4px;
				border-radius: 4px;
    }
    .minimalInput::placeholder{
        color: white;
        font-size: 18px;
        line-height: 1;
    }
    .minimalInput:focus {outline:0;}
</style>
